import {
  GET_MATCH_CARD_EVENT_REQUEST,
  GET_MATCH_CARD_EVENT_SUCCESS,
  GET_MATCH_CARD_EVENT_FAILURE,
  MATCH_CARD_EVENT_UPDATE,
  MATCH_CARD_EVENT_REMOVED,
  MATCH_CARD_EVENT_ADDED,
  GET_CLICKED_POINT,
  RESET_MATCH_CARD
} from 'Store/constants';
import {
  EVENT_FIELD_MAPPING
} from 'Store/constants/sportTypes';

const initialState = {
  data: {},
  isLoading: null,
  error: null,
  isFetched: false,
  clickedPoint: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_EVENT_REQUEST:
      return { ...initialState, isLoading: true, error: null, isFetched: false, clickedPoint: state.clickedPoint };
    case GET_MATCH_CARD_EVENT_SUCCESS:
      return { ...initialState, data: { ...action.payload }, isLoading: false, error: null, isFetched: true, clickedPoint: state.clickedPoint };
    case GET_CLICKED_POINT:
      return { ...state, clickedPoint: action.payload  };
    case GET_MATCH_CARD_EVENT_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload, isFetched: true };

    case MATCH_CARD_EVENT_UPDATE: {
      const { updatedEvent } = action.payload;

      return {
        ...state,
        data: {
          ...updatedEvent
        }
      };
    }
  
    case MATCH_CARD_EVENT_REMOVED: {
      return {
        ...state,
        data: {
          ...state.data,
          [EVENT_FIELD_MAPPING.bettingStatus]: 0
        }
      };
    }
  
    case MATCH_CARD_EVENT_ADDED: {
      return {
        ...state,
        data: {
          ...state.data,
          [EVENT_FIELD_MAPPING.bettingStatus]: 1
        }
      };
    }

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
